import script from "./activity.vue?vue&type=script&setup=true&lang=js"
export * from "./activity.vue?vue&type=script&setup=true&lang=js"

import "./activity.vue?vue&type=style&index=0&id=33171e52&lang=scss&scoped=true"
import "./activity.vue?vue&type=style&index=1&id=33171e52&lang=scss"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33171e52"]])

export default __exports__